import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchIncomes = createAsyncThunk('incomes/fetchIncomes', async ({ page = 1, startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  try {
    const params = { page, per_page: 20 };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await api.get('/incomes', { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener ingresos');
  }
});

export const createIncome = createAsyncThunk('incomes/createIncome', async (incomeData, { rejectWithValue }) => {
  try {
    const response = await api.post('/incomes', incomeData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al crear ingreso');
  }
});

export const updateIncome = createAsyncThunk('incomes/updateIncome', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.put(`/incomes/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al actualizar ingreso');
  }
});

export const deleteIncome = createAsyncThunk('incomes/deleteIncome', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/incomes/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al eliminar ingreso');
  }
});

const incomesSlice = createSlice({
  name: 'incomes',
  initialState: {
    incomes: [],
    pagination: { total: 0, pages: 1, page: 1, per_page: 20 },
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncomes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIncomes.fulfilled, (state, action) => {
        state.loading = false;
        state.incomes = action.payload.items;
        state.pagination = {
          total: action.payload.total,
          pages: action.payload.pages,
          page: action.payload.page,
          per_page: action.payload.per_page,
        };
      })
      .addCase(fetchIncomes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = incomesSlice.actions;
export default incomesSlice.reducer;
